import { ConsolidatedLabelDetail } from '../../../../../core/models/picking/consolidated-label-detail.model';
import { STATE_ORDER } from '../../../../../picking/picking-shared/enum/state-order.enum';
import { DataTable } from '../../data-table.interface';
import { DataTableExternal } from '../../data-table-external.interface';

export const TYPE_CONSOLIDATED_DETAIL = {
  CANCEL: 'CONSOLIDATED_DETAIL_CANCEL'
};


type OSN = 'O' | 'S' | 'N';

const getTypeLetter = (e: ConsolidatedLabelDetail): OSN => {
  if (e.addedBy === 'CLIENT') { return 'O'; }
  if (e.statusItem === 'ADDED' && e.addedBy === 'PICKER' && e.orderIdReplacedTo && e.orderIdReplacedTo !== 0) { return 'S'; }
  if (e.statusItem === 'ADDED' && e.addedBy === 'PICKER' && (!e.orderIdReplacedTo || e.orderIdReplacedTo === 0)) { return 'N'; }
  return 'O';
};

const orderRank: Record<OSN, number> = { O: 0, S: 1, N: 2 };

const buildOriginalIndex = (rows: ConsolidatedLabelDetail[]): Map<number, number> => {
  const m = new Map<number, number>();
  rows.forEach((r, idx) => { if (getTypeLetter(r) === 'O') { m.set(r.id, idx); } });
  return m;
};

const compareOSN = (
  a: ConsolidatedLabelDetail,
  b: ConsolidatedLabelDetail,
  allData: ConsolidatedLabelDetail[]
) => {
  const ta = getTypeLetter(a);
  const tb = getTypeLetter(b);

  const groupA = (ta === 'S' ? a.orderIdReplacedTo : a.id) || Number.MAX_SAFE_INTEGER;
  const groupB = (tb === 'S' ? b.orderIdReplacedTo : b.id) || Number.MAX_SAFE_INTEGER;

  const idxMap = buildOriginalIndex(allData);

  const coalesce = <T>(v: T | null | undefined, fallback: T): T =>
    (v == null ? fallback : v);

  const grpRankA = (ta === 'N')
    ? Number.MAX_SAFE_INTEGER
    : coalesce(idxMap.get(groupA), Number.MAX_SAFE_INTEGER - 1);

  const grpRankB = (tb === 'N')
    ? Number.MAX_SAFE_INTEGER
    : coalesce(idxMap.get(groupB), Number.MAX_SAFE_INTEGER - 1);

  if (grpRankA !== grpRankB) { return grpRankA - grpRankB; }

  const inRankA = orderRank[ta];
  const inRankB = orderRank[tb];
  if (inRankA !== inRankB) { return inRankA - inRankB; }

  if (ta === 'S' && tb === 'S' && groupA === groupB) { return a.id - b.id; }

  return a.id - b.id;
};



export const consolidatedPickingDetail: DataTable = {
  searchText: '',
  addText: '',
  checkbox: true,
  expandable: false,
  paginator: true,
  filter: false,
  filterDefault: '',
  disabled: false,
  partialField: '',
  show: 'No se encontraron resultados para mostrar.',
  hasDisabledCheckBoxItem: (item: any) => {
    // if (VALIDATE_ROLES()) {
    //   return true;
    // }
    switch (item.state) {
      case STATE_ORDER.RE_ENTRY:
        return false;
      default:
        return true;
    }
  },
  iconsOfActions: [
    { icon: 'cancel', tooltip: 'Cancelar', type: TYPE_CONSOLIDATED_DETAIL.CANCEL }
  ],
  columns: [
    {
      title: 'Descripción',
      name: 'description',
      type: 'string',
      value: (element: ConsolidatedLabelDetail) => (element.description).replace('�', '')
    },
    {
      title: 'Cant. solicitada',
      name: 'amountTotal',
      type: 'string',
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.amountTotal
    },
    {
      title: 'Cant. pickeada',
      name: 'amountConsolidated',
      type: 'string',
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.amountConsolidated
    },
    {
      title: 'Cant. Cancelada',
      name: 'amountMissing',
      type: 'string',
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.amountMissing
    },
    {
      title: 'Motivo',
      name: 'reasonDescription',
      type: 'string',
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.reasonDescription
    },
    {
      title: 'Estado',
      name: 'state',
      type: 'string',
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.state
    },
    {
      title: 'Fecha pre - cancelación',
      name: 'preCancelledAt',
      type: 'string',
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.preCancelledAt
    },
    {
      title: 'Etiqueta/Jaba',
      name: 'labelSerialNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      value: (element: ConsolidatedLabelDetail) => element.labelSerialNumber ? element.labelSerialNumber : '-'
    },
    {
      title: 'Ubicación.',
      name: 'location',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      value: (element: ConsolidatedLabelDetail) => element.location ? element.location : '-'
    },
    {
      title: 'Pickeador',
      name: 'pickerName',
      type: 'string',
      sortServer: true,
      value: (element: ConsolidatedLabelDetail) => {
        return element.pickerName ? element.pickerName : '';
      }
    },
    {
      title: 'Nº Lote',
      name: 'lotNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.lotNumber ? element.lotNumber : '-'
    },
    {
      title: 'Código de viaje',
      name: 'tripId',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.tripId ? element.tripId : '-'
    }
  ]
};


export const consolidatedPickingDetailExtern: DataTableExternal = {
  searchText: '',
  addText: '',
  checkbox: true,
  expandable: false,
  paginator: true,
  filter: false,
  filterDefault: '',
  disabled: false,
  partialField: '',
  show: 'No se encontraron resultados para mostrar.',
  hasDisabledCheckBoxItem: (item: any) => {
    // if (VALIDATE_ROLES()) {
    //   return true;
    // }
    switch (item.state) {
      case STATE_ORDER.RE_ENTRY:
        return false;
      default:
        return true;
    }
  },
  iconsOfActions: [
    { icon: 'cancel', tooltip: 'Cancelar', type: TYPE_CONSOLIDATED_DETAIL.CANCEL }
  ],
  columns: [
    {
      title: 'T. producto',
      name: 'productType',
      type: 'string',
      class: 'center',
      value: (e: ConsolidatedLabelDetail) => getTypeLetter(e),
      sort: (a, b, allData) => compareOSN(a, b, allData),
    },
    {
      title: 'Descripción',
      name: 'description',
      type: 'string',
      value: (element: ConsolidatedLabelDetail) => (element.description).replace('�', '')
    },
    {
      title: 'Cant. solicitada',
      name: 'amountTotal',
      type: 'string',
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.amountTotal
    },
    {
      title: 'Cant. pickeada',
      name: 'amountConsolidated',
      type: 'string',
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.amountConsolidated
    },
    {
      title: 'Cant. Cancelada',
      name: 'amountMissing',
      type: 'string',
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.amountMissing
    },
    {
      title: 'Motivo',
      name: 'reasonDescription',
      type: 'string',
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.reasonDescription
    },
    {
      title: 'Estado',
      name: 'state',
      type: 'string',
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.state
    },
    {
      title: 'Fecha pre - cancelación',
      name: 'preCancelledAt',
      type: 'string',
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.preCancelledAt
    },
    {
      title: 'Etiqueta/Jaba',
      name: 'labelSerialNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      value: (element: ConsolidatedLabelDetail) => element.labelSerialNumber ? element.labelSerialNumber : '-'
    },
    {
      title: 'Ubicación.',
      name: 'location',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      value: (element: ConsolidatedLabelDetail) => element.location ? element.location : '-'
    },
    {
      title: 'Pickeador',
      name: 'pickerName',
      type: 'string',
      sortServer: true,
      value: (element: ConsolidatedLabelDetail) => {
        return element.pickerName ? element.pickerName : '';
      }
    },
    {
      title: 'Nº Lote',
      name: 'lotNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.lotNumber ? element.lotNumber : '-'
    },
    {
      title: 'Código de viaje',
      name: 'tripId',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.tripId ? element.tripId : '-'
    },
    {
      title: 'Motivo de cancelación',
      name: 'cancellationReason',
      type: 'string',
      class: 'center',
      value: (element: ConsolidatedLabelDetail) => element.cancellationReason || '-'
    }
  ]
};
